import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@/components/Tooltip';
import { useDialogsContext } from '@/contexts/DialogsContext';
import GoodItem
  from '@/modules/proposalRequest/components/ProposalCreateForm/ProposalVerifyData/components/PartnerProposal/components/GoodItem/GoodItem';
import { DIALOG_PARTNER_GOODS_NAMESPACE } from '@/modules/proposalRequest/components/ProposalCreateForm/ProposalVerifyData/components/PartnerProposal/components/GoodsCreateForm/constants/goods';
import GoodsCreateForm
  from '@/modules/proposalRequest/components/ProposalCreateForm/ProposalVerifyData/components/PartnerProposal/components/GoodsCreateForm/GoodsCreateForm';
import { showPrice } from '@/utils/utils';

const ContributionGoods = ({ value, index, onChange, onlyRead, proposal, partner, hideCommunityProperty, ...rest }) => {
  const { t } = useTranslation('proposalRequest');
  const { openDialog } = useDialogsContext(`${DIALOG_PARTNER_GOODS_NAMESPACE}_${index}`);
  let [data, setData] = useState(value || []);
  
  useEffect(() => {
    setData(value || []);
  }, [value]);
  
  const onAddRequest = useCallback(() => {
    openDialog();
  }, [openDialog]);
  
  const onEditGood = useCallback(async (record, i) => {
    openDialog({ data: { ...record }, isEdit: true, recordIndex: i });
  }, [openDialog]);
  
  const onDeleteGood = useCallback(async (index) => {
    const copy = data[index];
    const wasDeleted = data.splice(index, 1);
    if (copy && wasDeleted) {
      setData([...data]);
      onChange([...data]);
    }
  }, [data, onChange]);
  
  const onAddEditGood = useCallback(async (good, isEdit, recordIndex) => {
    return new Promise((resolve, reject) => {
      try {
        if (!isEdit) {
          data.push(good);
        } else {
          data[recordIndex] = good;
        }
        setData([...data]);
        onChange([...data]);
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }, [data, onChange]);
  
  return (
    <>
      <GoodsCreateForm
        onConfirm={onAddEditGood}
        index={index}
        owner={partner}
        hideCommunityProperty={hideCommunityProperty}/>
      <div>
        {isEmpty(data) && onlyRead && showPrice('0')}
        {data?.map((e, i) => <GoodItem
          data={e}
          key={i}
          index={i}
          owner={partner || proposal?.owner}
          onlyRead={onlyRead}
          onEdit={() => onEditGood(e, i)}
          onDelete={() => onDeleteGood(i)}
          hideCommunityProperty={hideCommunityProperty}
          {...rest}
        />)}
        {!onlyRead &&
        <Tooltip title={t('proposalRequest.form.partners.goods.attachment.addButtonText')} placement="right">
          <Button
            type={'primary'}
            onClick={onAddRequest}
            className={'cursor-pointer bg-secondary border-secondary'}
            size={'large'} icon={<PlusOutlined/>}
          >
            <div className="ml-2 hidden md:inline">{t('create')}</div>
          </Button>
        </Tooltip>}
      </div>
    </>
  );
};

ContributionGoods.propTypes = {
  index: PropTypes.number,
  proposal: PropTypes.object,
  partner: PropTypes.object,
  onlyRead: PropTypes.bool,
  hideCommunityProperty: PropTypes.bool,
  value: PropTypes.array,
  onChange: PropTypes.func
};

ContributionGoods.defaultProps = {};

export default memo(ContributionGoods);
